import api from '../../http/requests/api/index.js'
import state from './apiState'

export default {
  setSelectedCity ({commit}, payload) {
    commit('SET_SELECTED_CITY', payload)
  },
  setSelectedImage ({commit}, payload) {
    commit('SET_SELECTED_IMAGE', payload)
  },
  getProductList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getProductList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_PRODUCT_CATEGORIES_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCateringProductList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getCateringProductList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CATERING_CATEGORIES_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getProduct ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getProduct(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response.data.data)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantListAll ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getRestaurantListAll(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_RESTAURANT_LIST_ALL', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getCateringRestaurantList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getCateringRestaurantList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CATERING_RESTAURANT_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantListAllRestaurants ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getRestaurantListAllRestaurants()
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getRestaurantList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_RESTAURANT_LIST_ALL', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getClosedRestaurantList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getClosedRestaurantList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getHomeRestaurantList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getHomeRestaurantList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getAreaList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getAreaList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getAreaListAll ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getAreaListAll(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_AREA_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getAreaRestaurantList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getAreaRestaurantList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getSearchData ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSearchData(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_SEARCH_DATA', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getSearchRestaurantData ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSearchRestaurantData(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_SEARCH_RESTAURANT_DATA', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCoupon ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getCoupon(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject(response)
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getGift ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getGift(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject(response)
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurant ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getRestaurant(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_RESTAURANT', response.data.data[0])
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantByEmail ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getRestaurantByEmail(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            //commit olmadan çalıştırmanın bir yolunu bulamadım, o yüzden boş mutation gönderiyorum
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantId ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getRestaurant(payload)
        .then(response => {


          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_RESTAURANT', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantEmail ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getRestaurant(payload)
        .then(response => {


          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_RESTAURANT', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },

  getCartRestaurantId ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getRestaurant(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CHECKOUT_RESTAURANT', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
        })
        .catch(error => { reject(error) })
    })
  },
  getOrder ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getOrder(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }
        })
        .catch(error => { reject(error) })
    })
  },

  getUser ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getUser()
        .then(response => {
          if (response.data.status === true) {
            commit('SET_USER', JSON.parse(JSON.stringify(response.data.data)))
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  loginUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.loginUser(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_USER', JSON.parse(JSON.stringify(response.data.data)))
            localStorage.accessToken = response.data.token
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  forgotPassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.forgotPassword(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  resetPassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.resetPassword(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.registerUser(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_TOKEN_VALID', false)
            resolve(response.data)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  claimBusiness ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.claimBusiness(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  changePassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.changePassword(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  verifyMail ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.verifyMail(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  checkTokenValid ({ commit }) {

    return new Promise((resolve, reject) => {
      api.checkToken()
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_TOKEN_VALID', true)
            resolve(response)
          } else {
            commit('SET_TOKEN_VALID', false)
            reject({message: response.data.status})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getAddressList ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAddressList()
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_ADDRESS_LIST', response.data.data)
            for (let i = 0; i < response.data.data.length; i++) {
              const address = response.data.data[i]
              if (address.default) {
                commit('SET_DEFAULT_ADDRESS', address)
                break
              } else if (i === response.data.length - 1) {
                const replace_address = response.data.data[0]
                commit('SET_DEFAULT_ADDRESS', replace_address)
              }
            }
            try {
              if (state.deliveryAddress.id === 0) {
                commit('SET_DELIVERY_ADDRESS', state.defaultAddress)
              }
            } catch (e) {
              console.log(e)
            }
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  saveOrder ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.saveOrder(payload)
        .then(response => {
          if (response.data.status === true) {
            resolve(response)
            commit()
          } else {
            reject({message: response.data.message})
          }
        }).catch(error => { reject(error) })
    })
  },
  orderCheck ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.orderCheck(payload)
        .then(response => {
          resolve(response.data)
          commit()
        }).catch(error => { reject(error) })
    })
  },
  getDeliveryFee ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getDeliveryFee(payload)
        .then(response => {
          if (response.data.status === true) {
            resolve(response.data)
            commit()
          } else {
            reject({message: response.data.message})
          }
        }).catch(error => { reject(error) })
    })
  },
  saveOffer ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.saveOffer(payload)
        .then(response => {
          if (response.data.status === true) {
            resolve(response)
            commit()
          } else {
            reject({message: response.data.message})
          }
        }).catch(error => { reject(error) })
    })
  },
  deleteAddress ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.deleteAddress(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit()
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addNewAddress ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.saveAddress(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            const address_payload = {
              addressId: response.data.data
            }

            api.getAddress(address_payload).
              then(response_address => {
                if (response_address.data.status === true) {
                  commit('PASS', true)
                  resolve(response)
                } else {
                  reject({message: response_address.data.message})
                }
              }).
              catch(error => {
                reject({message: error.data.message})
              })
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  saveUser ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.saveUser(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  uploadImage ({commit}, payload, onUploadProgress) {
    return new Promise((resolve, reject) => {
      api.uploadImage(payload, onUploadProgress)
        .then(response => {
          if (response.data.status === true) {
            commit('')
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  orderList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getOrderList(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('SET_ORDER_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  contentList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getContentList(payload)
        .then(response => {
          if (response.data.status === true) {
            if (payload.contentType === 'page') {
              commit('SET_PAGE_CONTENTS', response.data.data)
            } else if (payload.contentType === 'blog') {
              commit('SET_BLOG_CONTENTS', response.data.data)
            } else if (payload.contentType === 'coupon-banner') {
              commit('SET_COUPON_BANNER_CONTENTS', response.data.data)
            } else if (payload.contentType === 'coupon-slider') {
              commit('SET_COUPON_SLIDE_CONTENTS', response.data.data)
            } else if (payload.contentType === 'special-slider') {
              commit('SET_SPECIAL_SLIDE_CONTENTS', response.data.data)
            } else if (payload.contentType === 'event-slider') {
              commit('SET_EVENT_SLIDE_CONTENTS', response.data.data)
            } else {
              commit('SET_CONTENTS', response.data.data)
            }
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  eventList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.eventList(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  liveCityList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.liveCities(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            commit('SET_LIVE_CITY', response.data.data)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getAreaText ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getAreaText(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response.data)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  campaignList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getCampaignList(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCouponList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getCouponList(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('SET_COUPONS', response.data.data)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getContent ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getContent(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('SET_CURRENT_CONTENT', response.data.data)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getPiSecret ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getPiSecret(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCateringData ({ commit }, payload) {
    
    return new Promise((resolve, reject) => {
      api.getCateringData(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response.data)
            commit('PASS', true)
          } else {
            reject(response.data)
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  sendRestaurantOffer ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.sendRestaurantOffer(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response.data)
          } else {
            reject(response.data)
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  getDeliveryMethod ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getDeliveryMethod(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            commit('SET_DELIVERY_METHOD', response.data.data)
            resolve(response.data)
          } else {
            reject(response.data)
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  sendContact ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.sendContact(payload)
        .then(response => {
          resolve(response.data)
          commit()
        }).catch(error => { reject(error) })
    })
  },
  getGiftCards ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getGiftCards(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            commit('SET_GIFT_CARD', response.data.data)
            resolve(response.data)
          } else {
            reject(response.data)
          }
        })
        .catch(error => { reject(error) })
    })
  },
  setGiftCards ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.setGiftCards(payload)
        .then(response => {
          resolve(response.data)
          commit()
        }).catch(error => { reject(error) })
    })
  },
  getRestaurantSales ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getRestaurantSales(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurantSale ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getRestaurantSale(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  sendRestaurantSale ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.sendRestaurantSale(payload)
        .then(response => {
          resolve(response.data)
          commit()
        }).catch(error => { reject(error) })
    })
  },
  getReviews ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getReviews(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response.data)
          } else {
            reject({message: response.data.message})
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  sendRestaurantReview ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.sendRestaurantReview(payload)
        .then(response => {
          resolve(response.data)
          commit()
        }).catch(error => { reject(error) })
    })
  }
}
